export default __webpack_public_path__ + "assets/67fd3b7636ebc6648ebc5b901bec4ecf.svg";